var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"headerBg"},[_c('div',{staticClass:"headerCenter"},[_c('a',{staticClass:"headerLogoArea",attrs:{"href":"#"}},[_c('img',{staticClass:"headerLogoImg",attrs:{"src":require("@/assets/img/surreal_ed_logo.png")}}),_c('span',{staticClass:"headerLogoTxt"},[_vm._v("英語小鬥士風雲榜後台")])])])]),_c('div',{staticStyle:{"width":"100%","height":"86px"}})])
}]

export { render, staticRenderFns }